import React from 'react'

import {
  ContextualMenu,
  Link,
  MenuDivider,
  MenuEntry,
  MenuSection,
  Stack,
  Text,
} from '@procsea/design-system'

import { useMarketplaceQuery } from 'src/queries/shared/marketplace/marketplace'

import { useKnowledgeBaseUrl } from './useKnowledgeBaseUrl'

const HelpCenterContextMenu = () => {
  const knowledgeBaseUrl = useKnowledgeBaseUrl()
  const { data: marketplace } = useMarketplaceQuery()

  const isHelpCenterVisible = !marketplace?.length && !!knowledgeBaseUrl

  return isHelpCenterVisible ? (
    <Stack spacing="medium">
      <MenuDivider />
      <ContextualMenu
        button={
          <MenuEntry
            config={{ disableActiveState: true }}
            data-e2e="menu-entry-help-center"
            hasChevron
            icon="question-circle"
            label={gettext('Help center')}
          />
        }
        data-e2e="help-center-context-menu"
        placement="right"
        fallbackPlacements={['bottom', 'auto']}
      >
        <MenuSection>
          {!!knowledgeBaseUrl && (
            <MenuEntry
              data-e2e="menu-entry-knowledge-base"
              icon="book-open"
              label={
                <Link href={knowledgeBaseUrl} underline={false}>
                  <Text size="large">{gettext('Knowledge base')}</Text>
                </Link>
              }
            />
          )}
        </MenuSection>
      </ContextualMenu>
    </Stack>
  ) : null
}

export default HelpCenterContextMenu
